import React, { useEffect, useState } from "react";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { getType } from "../../../utils/date";
import { useGetDriversMutation } from "../../../store/api/lumi/drivers";
import { debounce } from "lodash";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "../DocumentsViewer/DocumentsViewer.module.css";

const AverageScoreViewer = (props) => {
    const [isLoading, seIstLoading] = useState(false);
    const [averageScore, setAverageScore] = useState([]);
    const [getDriver] = useGetDriversMutation();

    async function getDriversData() {
        try {
            seIstLoading(true);
            const conceptFilter = getConceptFilter(props);

            const { data: dataConcepts } = await getDriver({
                id: props.id,
                score_field: props.selectedFieldDriverName,
                concept_selector: conceptFilter,
                filter: props.filters,
                match_type: getType(props.seletctedType),
            });

            if (dataConcepts && dataConcepts.length > 0 && dataConcepts[0].baseline !== undefined) {
                setAverageScore(dataConcepts[0].baseline);
            } else {
                setAverageScore(null);
            }
        } finally {
            seIstLoading(false);
        }
    }


    useEffect(() => {
        if (props.selectedFieldDriverName) {
            seIstLoading(true);
            const debouncedGetVolume = debounce(getDriversData, 500);
            debouncedGetVolume();

            return () => {
                debouncedGetVolume.cancel();
            };
        }
    }, [
        props.selectedFieldDriverName,
        props.filters,
    ]);

    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }

    return (
        <div className={styles.documentsViewerContainer}>
            <div className={styles.documentsViewerInner}>
                {averageScore ?
                    <>
                        <div className={styles.docCount}>
                            {Number(averageScore).toFixed(1)}
                        </div>
                    </>
                    : <p>Field range to small</p>
                }
            </div>

        </div>
    );
};

export default AverageScoreViewer;